const getAcceptedPaymentCards = (hotelItineraries) => {
  if (!hotelItineraries || !hotelItineraries.length) return {};

  const acceptedCards = hotelItineraries.reduce((acc, hotelItinerary, index) => {
    if (
      hotelItinerary.selectedProduct &&
      hotelItinerary.selectedProduct.rooms &&
      hotelItinerary.selectedProduct.rooms[0].acceptedPaymentCards
    ) {
      const currentAcceptedCards = hotelItinerary.selectedProduct.rooms[0].acceptedPaymentCards;

      if (index === 0) {
        return { ...currentAcceptedCards };
      }
      Object.keys(acc).forEach((card) => {
        if (!currentAcceptedCards[card]) {
          delete acc[card];
        }
      });
      return acc;
    }
    return acc;
  }, {});
  return acceptedCards;
};

export default getAcceptedPaymentCards;
